import angular from 'angular';

export class subscribeListComponent {
  studentDataPage = {};
  filterText = '';
  listData = [];

  /*@ngInject*/
  constructor($http, $state, $stateParams, OrderNnw, insuranceOffer, Document, $scope, LeftNav, $q, pageSettings,
              Subscribe, helper) {
    let vm = this;
    vm.cloakView = true;
    vm.pageSettings = pageSettings;
    vm.LeftNav = LeftNav;
    vm.Subscribe = Subscribe;


    vm.query = {
      page: 1,
      limit: 100000,
      query: null,

    };

    // LISTENERS
    const loadingBarDisabler = $scope.$on('cfpLoadingBar:completed', function() {
      vm.cloakView = false;
      loadingBarDisabler();
    });

    vm.success = data => {
      vm.listData = data.data;
      vm.deferred.resolve();
    };

    vm.getSubscribeList = function() {
      vm.deferred = $q.defer();
      vm.promise = vm.deferred.promise;
      vm.Subscribe.getList(this.query)
        .then(vm.success);
    };
  }

  $onInit() {
    this.LeftNav.setActive('clients', 'main.students');
    this.pageSettings.setTitle('APPLICATION.TITLE.SUBSCRIBE_SPORT');
    this.pageSettings.setState('main.subscribeList');
    this.pageSettings.setTheme('subscribeList');
    this.getSubscribeList();
  }
}

export default angular.module('ngOskCrmApp.main.subscribeList', [])
  .component('subscribeList', {
    template: require('./subscribe-list.pug'),
    controller: subscribeListComponent,
    controllerAs: 'vm'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/subscribe-list/subscribe-list.component.js